import Collections from "%/dynamic-component-editor/standard-elements/Collections.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyCollections extends LegacyEntity {
  get elements() {
    return {
      Collections,
    };
  }
}
